import { baseQuery } from '../baseQuery';

type SendSmsParams = {
  taskId: number;
  message: string;
  to_number: string;
  sms_to: 'C' | 'T' | 'O';
};

export const putTaskSendSms = async ({ taskId, message, to_number, sms_to }: SendSmsParams) => {
  const data = await baseQuery('task/sms', {
    type: 'PUT',
    body: {
      task_ID: taskId,
      message,
      sms_to,
      to_number,
    },
  });

  return data;
};
